import { useBreakpointRange } from './BreakpointRangeProvider';
import { BreakpointRangeValue } from './types';

export interface BreakpointRangeHocState<B> {
    breakpointRange?: B;
}

export type BreakpointRangeProps<B = BreakpointRangeValue> = BreakpointRangeHocState<B>;
/**
 * Passes breakpoint ranges to component.
 *
 * Use functions in ./utils to compare breakpoint ranges.
 */
const withBreakpointRange = <P extends BreakpointRangeProps<unknown>, B = P['breakpointRange']>(
    Component: React.ComponentType<P> | React.ForwardRefExoticComponent<P>
) => {
    const BreakpointRangeConsumer = (props: Omit<P, 'breakpointRange'>) => {
        const breakpointRange = useBreakpointRange<B>();
        return <Component {...(props as P)} breakpointRange={breakpointRange} />;
    };
    return BreakpointRangeConsumer;
};

export default withBreakpointRange;
